import { Navigate, useLocation } from "react-router-dom";
import { type ReactNode } from "react";
import { useEmployeeSession } from "@/store/EmployeeSessionContext";

/* ────────────────────────────────────────────────────────────────────
 * Employee route guard — reads from EmployeeSessionContext.
 * ──────────────────────────────────────────────────────────────────── */
type EmployeeProps = { children: ReactNode };

export function EmployeeProtectedRoute({ children }: EmployeeProps) {
  const { employee } = useEmployeeSession();
  const location = useLocation();
  if (!employee) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

/* ────────────────────────────────────────────────────────────────────
 * Manager route guard — checks localStorage flag, no Firebase Auth.
 * ──────────────────────────────────────────────────────────────────── */
type ManagerProps = { children: ReactNode };

export function ManagerProtectedRoute({ children }: ManagerProps) {
  const authed = localStorage.getItem("manager_auth") === "1";
  if (!authed) {
    return <Navigate to="/manager/login" replace />;
  }
  return <>{children}</>;
}
